import { render, staticRenderFns } from "./NavigationLinkBeta.vue?vue&type=template&id=61dce238&"
import script from "./NavigationLinkBeta.vue?vue&type=script&lang=ts&"
export * from "./NavigationLinkBeta.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationLinkBeta.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports